module.exports = __webpack_public_path__ + "static/media/education-7.6484e9d5.png";